<template>
    <header>
        <el-row :gutter="10">
            <el-col :sm="24" :lg="18">
                <slot></slot>
            </el-col>
            <el-col :sm="24" :lg="6" class="text-right">
                <router-link :to="baseRoute.path">
                    <el-button>Submit project</el-button>
                </router-link>
                <el-button v-if="isLogged" @click="logout">Logout</el-button>
                <router-link v-else :to="loginLink">
                    <el-button>Login</el-button>
                </router-link>
                <div class="navbutton">
                    <input class="checkbox" type="checkbox" v-model="drawer"/>
                    <div class="hamburger-lines">
                        <span class="line line1"></span>
                        <span class="line line2"></span>
                        <span class="line line3"></span>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-drawer title="Menu" :visible.sync="drawer" direction="rtl" :with-header="false">
            <div class="drawermenu">
                <div class="drawersection">
                    <a href="#" v-if="isLogged" @click.prevent="logout">Logout</a>
                    <router-link v-else :to="loginLink">
                        Login
                    </router-link>
                </div>
                <div class="drawersection">
                    <a href="https://globaldesignnews.com/about/" target="_blank">About Global Design News</a>
                    <a href="https://globaldesignnews.com/awards/prize-design-furniture-lighting/" target="_blank">About Prize Designs</a>
                    <a href="https://globaldesignnews.com/awards/prize-design-furniture-lighting/" target="_blank">About Future House Awards</a>
                    <a href="https://metropolitanartspress.com/shop/" target="_blank">Metropolitan Arts Press</a>
                    <a href="https://www.chi-athenaeum.org/" target="_blank">The Chicago Athenaeum Museum</a>
                </div>
                <div class="drawersection">
                    <a href="#">Instructions for Prize Designs for Modern Furniture and Lighting</a>
                    <a href="#">Instructions for Future House Awards</a>
                    <a href="/pdf/bank_transfer_general.pdf" target="_blank">Bank Transfer Details</a>
                    <a href="/pdf/postal_application_prize_designs.pdf" target="_blank">Postal Application for Prize Designs</a>
                    <a href="/pdf/postal_application_future_house.pdf" target="_blank">Postal Application for Future House Awards</a>
                    <a href="https://metropolitanartspress.com/shop/architecture/New%20-Modern-%20Furniture-Lighting" target="_blank">Prize Designs  for Modern Furniture and Lighting Book Order</a>
                    <a href="https://metropolitanartspress.com/shop/architecture/Future%20-House-%20The-%20New-%20Domestic-%20Landscape" target="_blank">Future House Awards Book Order</a>
                    <a href="https://globaldesignnews.com/terms-and-conditions/" target="_blank">Terms & Conditions</a>
                    <a href="https://metropolitanartspress.com/shop/terms" target="_blank">Refund Policy</a>
                </div>
            </div>
        </el-drawer>
    </header>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {TOGGLE_COLLAPSE} from '../store/types'

export default {
    name: 'Header',
    data: () => ({
        drawer: false
    }),
    methods: {
        ...mapMutations([TOGGLE_COLLAPSE]),
        logout: function () {
            this.$auth.logout({
                makeRequest: true,
                redirect: null
            }).then(() => {
                this.$router.push(this.loginLink);
            }, error => {
                if (error.response.status === 422)
                    this.authErrors = error.response.data.errors
            })
                .finally(() => this.loading = false)
        },
        collapse() {
            this[TOGGLE_COLLAPSE]()
        },
    },
    computed: {
        ...mapGetters(['coreIsCollapsed'])
    },
    mounted() {
        const user = this.$auth.user()
    }
}
</script>
